import styled from 'styled-components'
import { breakpoints } from '../../../../constants'

export const StyledAddressSection = styled.div`
	font-size: 18px;
	display: flex;
	flex-direction: column;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-end;
	}

	& > :first-child {
		margin-bottom: 4rem;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			margin-bottom: 0;
		}
	}
`
